import {
  SimpleGrid,
  Skeleton,
  Stat,
  StatArrow,
  StatHelpText,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";
import {
  calculatePercentageChange,
  formatCurrency,
} from "../../../../utils/property-utils";
import type { PropertyStatsProps } from "./types";

export default function PropertyStats({
  stats,
  loading = false,
}: PropertyStatsProps) {
  if (loading) {
    return (
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={8}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} height="120px" borderRadius="lg" />
        ))}
      </SimpleGrid>
    );
  }

  const revenueGrowth = calculatePercentageChange(
    stats.monthlyRevenue,
    stats.lastMonthRevenue
  );

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={8}>
      {/* Monthly Revenue */}
      <Stat>
        <StatLabel>Receita (30 dias)</StatLabel>
        <StatNumber fontSize="2xl">
          {formatCurrency(stats.monthlyRevenue)}
        </StatNumber>
        <StatHelpText>
          {revenueGrowth !== 0 && (
            <>
              <StatArrow type={revenueGrowth > 0 ? "increase" : "decrease"} />
              {Math.abs(revenueGrowth).toFixed(1)}% vs mês anterior
            </>
          )}
        </StatHelpText>
      </Stat>

      {/* Occupancy Rate */}
      <Stat>
        <StatLabel>Taxa de Ocupação</StatLabel>
        <StatNumber fontSize="2xl">
          {stats.occupancyRate.toFixed(1)}%
        </StatNumber>
        <StatHelpText>Últimos 30 dias</StatHelpText>
      </Stat>

      {/* Total Reservations */}
      <Stat>
        <StatLabel>Total de Reservas</StatLabel>
        <StatNumber fontSize="2xl">{stats.totalReservations}</StatNumber>
        <StatHelpText>Todas as reservas ativas</StatHelpText>
      </Stat>

      {/* Average Stay Duration */}
      <Stat>
        <StatLabel>Duração Média</StatLabel>
        <StatNumber fontSize="2xl">
          {stats.averageStayDuration.toFixed(1)}
        </StatNumber>
        <StatHelpText>Dias por reserva</StatHelpText>
      </Stat>
    </SimpleGrid>
  );
}
